export enum AuditActivity {
    Creation = 'Creation',
    Modification = 'Modification',
    Deletion = 'Deletion',
    Download = 'Download',
    Upload = 'Upload'
}

export class AuditTrailDto {
    id: number = 0;
    date: Date;
    userId?: number;
    username: string = "";
    role: string = "";
    activity: AuditActivity;
    activityName: string = "";
    page: string = "";
    module: string = "";
    record: string = "";
    hasValueChanges: boolean = false;
    ipAddress: string = "";
    utilityId: number = 0;
}
